import { Button, Group, Modal } from "@assetwatch/ui";

export type UnsavedChangesDialogProps = {
  open: boolean;
  /** Dismisses the dialog and stays on the screen. */
  onKeepEditing: () => void;
  /** Throws the changes away and leaves. */
  onDiscard: () => void;
  /** Provide only when the screen can save its changes. */
  onSave?: () => void;
  saving?: boolean;
  title?: string;
  description?: string;
};

/**
 * The standard leave-with-unsaved-changes dialog. Keep editing is the single
 * way to stay, Discard is the single way to leave without saving, and Save
 * appears only on screens that can save.
 */
export function UnsavedChangesDialog({
  open,
  onKeepEditing,
  onDiscard,
  onSave,
  saving = false,
  title = "Unsaved changes",
  description = "You have unsaved changes. Leave this page and discard them?",
}: UnsavedChangesDialogProps) {
  return (
    <Modal
      description={description}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onKeepEditing();
      }}
      open={open}
      size="md"
      title={title}
    >
      <Group gap={8} justify="end" wrap="wrap">
        <Button onClick={onKeepEditing} variant="ghost">
          Keep editing
        </Button>
        <Button
          intent="destructive"
          onClick={onDiscard}
          variant={onSave ? "ghost" : "primary"}
        >
          Discard
        </Button>
        {onSave ? (
          <Button loading={saving} onClick={onSave}>
            Save
          </Button>
        ) : null}
      </Group>
    </Modal>
  );
}
